import * as React from 'react';

interface IProps {
	initValue?: any,
	name?: string,
	value?: string,
	onChange: (data: any, item: any) => void,
	data?: IItemData[],
	canSearch?: () => boolean,
	load?: (term: string, fn: (data: IItemData[]) => void) => void;
}

export interface IItemData {
	id: string,
	label: string, 
}

export default class MultiInputBaseWrapper extends React.Component<IProps> {
	constructor(props) {
		super(props);

		this.elementInput = React.createRef();
	}

	elementInput: React.RefObject<HTMLInputElement>;
	jqTagsInput: any;
	addTag: boolean;
	jqAutocomplete: any;

	componentDidMount() {
		if (this.props.value) {
			this.elementInput.current.value = this.props.value;
		}
		this.tagsInputInit();

		if (this.props.initValue)
			this.addSelect(this.props.initValue);
	}

	addSelect(item) {
		var value = item.id + ':' + item.label;
		if (item.id != -1 && !this.jqTagsInput.tagExist(value)) {
			this.addTag = true;
			this.jqTagsInput.addTag(value);
			this.jqAutocomplete.toggleClass('not_valid', false);
			if (this.props.onChange)
				this.props.onChange({}, item);
			return true;
		}
		else {
			this.jqAutocomplete.toggleClass('not_valid', true);
			this.jqAutocomplete[0].value = '';
			return false;
		}
	}

	tagsInputInit() {
		let tagInput = this.elementInput.current;

		this.addTag = false;
		let tagsInput = (window as any).$(tagInput).tagsInput({
			width: '100%',
			height: 'auto',
			defaultText: '',
			autosize: false,
			interactive: true,
			delimiter: '*&*,',
			hideValueId: ':',
			onAddTag: (tag) => {
				if (!this.addTag)
					tagsInput.removeTag(tag);
				this.addTag = false;
			},
			onRemoveTag: (tag) => {
				let id = tag.split(":")[0];
				if (this.props.onChange)
					this.props.onChange({

					}, id);
			}
		});

		this.jqTagsInput = tagsInput;

		(window as any).$('#' + tagInput.id + '_addTag').addClass('input_wrapper');

		if (tagsInput.hasClass('input-validation-error')) {
			tagsInput.parent().addClass('input-validation-error');
			(window as any).$('#' + tagInput.id + '_tagsinput').addClass('input-validation-error');
		}

		let autocomplete = (window as any).$('#' + tagInput.id + '_tag');
		this.jqAutocomplete = autocomplete;
		autocomplete.attr("tabindex", 1);
		autocomplete.unbind('blur');
		autocomplete.autocomplete({
			minLength: 0,
			source: (request, response) => {
				let data = this.props.data;
				if (data && (!request.term || request.term == "")) {
					this.filterResult(data, response);
				}
				else if (this.props.load) {
					this.props.load(request.term, (data: IItemData[]) => {
						this.filterResult(data, response);
					});
				}
			},
			select: (e, u) => {
				let item = u.item;
				if (this.addSelect(item)) {
					autocomplete.focus();
				}
				return false;
			},
		});
		
		autocomplete.focus(() => {
			if (typeof this.props.canSearch === "function") {
				if (this.props.canSearch())
					autocomplete.autocomplete('search');
				else
					autocomplete.blur();
			}
			else
				autocomplete.autocomplete('search');
		});

		autocomplete.blur(() => {
			autocomplete[0].value = '';
		});
	}

	filterResult(data: IItemData[], response) {
		let filtered = [];
		for (let i = 0; i < data.length; i++) {
			let item = data[i];

			var value = item.id + ': ' + item.label;
			if (!this.jqTagsInput.tagExist(value)) {
				filtered.push(item);
			}
		}

		if (filtered.length == 0) {
			filtered = [{
				id: -1,
				value: "",
				label: "<brak elementów>"
			}]
		}
		response(filtered)
	}

	getValue() {
		if (this.jqTagsInput) {
			return this.jqTagsInput.getAllTags().map((value: string) => {
				let index = value.indexOf(":");
				let id = value.substr(0, index);
				let label = value.substr(index + 1);
				return {
					id: id,
					value: label,
					label: label
				}
			});
		}
		return [];
	}

	clear() {
		if (this.jqTagsInput) {
			return this.jqTagsInput.getAllTags().forEach((tag) => {
				this.jqTagsInput.removeTag(tag);
			});
		}
	}

	render() {
		return <div className="tags-container editor">
			<input ref={this.elementInput} type="hidden" name={this.props.name} />
		</div>
	}
}